/*
 * @Author: leventlei
 * @Date: 2024-01-07 09:49:51
 * @LastEditTime: 2024-12-21 17:40:18
 * @LastEditors: huasheng-c 957461792@qq.com
 * @Description:基本布局
 * @FilePath: \IOT4CMS\src\layouts\baseLayout\index.tsx
 */
import React, { FC, useEffect } from 'react'

import { GlobalModelState } from '@/models/connect'
import { Layout } from 'antd'
import { Dispatch, connect } from 'umi'
import HeaderContent from './header'
import MenuContent from './menu'
import { PreviewBOX } from '@/components'
const { Header, Content, Sider } = Layout

import styles from './index.less'
import ProjectSelect from './projectSelect'
interface BaseLayoutProps {
	children: any
	global: GlobalModelState
	dispatch: Dispatch
}

const BaseLayout: FC<BaseLayoutProps> = ({ children, global, dispatch }) => {
	useEffect(() => {
		if (Number(sessionStorage.getItem('_projectId')) !== 0) {
			return
		}
		dispatch({
			type: 'global/save',
			payload: {
				showProjectSelect: true,
			},
		})
	}, [])

	return (
		<>
			<Layout className={styles.container}>
				<Header className={styles.myHeader}>
					<HeaderContent />
				</Header>
				{global.showProjectSelect ? (
					<ProjectSelect />
				) : (
					<Layout style={{ padding: 0 }}>
						<Sider width={174} className={styles.sider}>
							<MenuContent />
						</Sider>
						<Content className={styles.content}>{children}</Content>
					</Layout>
				)}
				{/* <ProjectSelect /> */}
			</Layout>
			{global.showPreview && <PreviewBOX onClick={() => {}} data={undefined} />}
		</>
	)
}

export default connect(({ global }: { global: GlobalModelState }) => ({
	global,
}))(BaseLayout)
